import { takeUntil, tap, take } from 'rxjs';
/**
 * Created by Ko-Hsin on 17/09/2018.
 */
import { Injectable } from '@angular/core';
import { EventService } from './event.service';
import { Subject } from 'rxjs';
import { ErrorStreamChange } from '../models/$error.model';
import { UiService } from './ui.service';
import { ProgramService } from './program.service';
import { Store, select } from '@ngrx/store';
// import { ResetAllOnsiteTimelineData } from '../store/filters.era';
import { copyObjectWithProps, date_id, getSet } from 'globals/helpers/helpers';
import { LogService } from './log.service';
import { OnReset, Transitions } from './transition.service.helpers';
import { DLLNode, ProgramNodeDateMap, ProgramNode, OnsiteActivity, OnsiteSchedule, NewOnsiteData } from 'globals/store/onsite.data';
import { onsiteReselector } from '../store/reselectors/onsite.reselector';
// import { LoadCompleteButEmpty, LoadOnsiteActivitiesAndSchedules, RemoveActivities, RemoveSchedules,  } from '/store/onsite.era';
import { activityPropertyNames, onsiteActions, onsiteFeatures, schedulePropertyNames } from '../store/onsite.era';
import { environment } from '../../../src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { UserService } from './user.service';
import { JoiEvent, Venue } from 'globals/store/events.data';
import { Dictionary } from '@ngrx/entity';
import { eventsFeature } from '../store/events.era';
import { subTilDestroy } from '../helpers/helpers';
import { filterActions } from '../store/filters.era';
import { doc, DocumentData, docSnapshots, DocumentSnapshot, Firestore, setDoc, FieldValue, deleteField, docData } from '@angular/fire/firestore';

const extensionScheduleProps = new Set(["day", "id", "scheduleId", "extension"])
const cleanActivity = (activity: OnsiteActivity): OnsiteActivity => copyObjectWithProps(activityPropertyNames, activity)
const cleanSchedule = (schedule: OnsiteSchedule): OnsiteSchedule => copyObjectWithProps(schedulePropertyNames, schedule)
const cleanExtensionSchedule = (schedule: OnsiteSchedule): OnsiteSchedule => copyObjectWithProps(extensionScheduleProps, schedule)


@Injectable({ providedIn: 'root'})
export class ActivityService implements OnReset {
    // oseSchedules used for v2
    readonly _file:string = 'activity.service.ts';
    private $destroy_activites:Subject<boolean> = new Subject();
    _activities: Dictionary<OnsiteActivity> = {}
    _schedules: Dictionary<OnsiteSchedule> = {}

		dateNodesByDate: Map<string, DLLNode<string>>
		programNodesByDate: ProgramNodeDateMap
		programNodeCentersById: Map<String, ProgramNode>
    public $errors: Subject<ErrorStreamChange> = new Subject();
    public event: JoiEvent
    $destroy: Subject<boolean> = new Subject()
    private dontResetOnsiteTimelineTimeout
    readonly api = `${environment.functionsURL}api/app`;

    reset() {
      this.$destroy_activites.next(true)
      this.dateNodesByDate = new Map()
      this.programNodesByDate = {}
      this.programNodeCentersById = new Map()
    }

    onReset(resetType, value = null) {
      switch (resetType) {
        case Transitions.OnExitUser:
          this.reset()
          break;
        case Transitions.OnEnterEvent:
          this.getOnsiteData(value.eventId)
          break;
        case Transitions.OnExitEvent:
          this.reset()
          break;
        default:
          break;
      }
    }

    constructor(private eventService: EventService,
      private ui: UiService,
      private program: ProgramService,
      private log:LogService,
      public store: Store,
      private userService: UserService,
      private db: Firestore,
      private http: HttpClient,
    ) {
				const schedulesSubscription = this.store.select(onsiteReselector).subscribe(({ programNodesByDate,  dateNodesByDate, programNodeCentersById }) => {
					this.dateNodesByDate = dateNodesByDate
					this.programNodesByDate = programNodesByDate
					this.programNodeCentersById = programNodeCentersById
				})
        subTilDestroy(this, select(eventsFeature.selectEvent), 'event')
        subTilDestroy(this, select(onsiteFeatures.selectActivities), '_activities')
        subTilDestroy(this, select(onsiteFeatures.selectSchedules), '_schedules')
    }

    public getOnsiteData(eventId){
      // console.log("getActivities called!", eventId)
      docSnapshots(doc(this.db, 'onsite/' + eventId)).pipe( 
        tap((changes: DocumentSnapshot<NewOnsiteData, DocumentData>) => {
            if(!changes.exists()){
              this.store.dispatch(onsiteActions.loadCompleteButEmpty())
              return // this.log.error({file:this._file, function:'getActivities !changes.payload.exists',message:'No event by that id found',error:new Error()})
            }
            const onsiteData = changes.data() as NewOnsiteData
            // console.log({ onsiteData })
            this.store.dispatch(onsiteActions.loadActivitiesAndSchedules({onsiteData}))
            if (!this.dontResetOnsiteTimelineTimeout) {
              this.store.dispatch(filterActions.resetAllOnsiteTimelineData()) // <== this causes a bug when toggling activity complete inside of onsite timeline.  So I had to add the hack workaround
            }
          },
          (response)=>{
            this.log.error({file:this._file, function:'getOnsiteData',response,error:new Error()})
          }
        ),
        takeUntil(this.$destroy_activites)).subscribe()
    }

    public dontResetOnsiteTimelineTemporarily() { // <== for data changes that take place inside of onsite timeline

      if (this.dontResetOnsiteTimelineTimeout) clearTimeout(this.dontResetOnsiteTimelineTimeout)
      this.dontResetOnsiteTimelineTimeout = setTimeout(() => this.dontResetOnsiteTimelineTimeout = null, 5000)
    }
    
		private convertActivityWithDay(activity, day): OnsiteActivity {
			const act = <OnsiteActivity><unknown>activity
			act.day = day
			return <OnsiteActivity><unknown>copyObjectWithProps(activityPropertyNames, act)
		}

    private upsertWithDtoMapping({ activities, schedules, activityIdsToDelete, scheduleIdsToDelete }: 
      { activities?: OnsiteActivity[], schedules?: OnsiteSchedule[], activityIdsToDelete?: string[], scheduleIdsToDelete?: string[] }) { // Dto == Data transfer object
      const updateMap = {}
      const mergeFields = []
      if (activities?.length) activities.map(cleanActivity).forEach(a => {
        if(!updateMap['activities']) updateMap['activities'] = {}
        updateMap[`activities`][`${a.id}`] = a
        mergeFields.push(`activities.${a.id}`)
      })
      if (schedules?.length) {
        if (!Object.values(this._schedules).length) {
          console.log("Should be first schedule")
          updateMap['schedules'] = {}
          schedules.map(cleanSchedule).forEach(s => {
            updateMap['schedules'][s.id] = s
            mergeFields.push(`schedules.${s.id}`)
          })
        } else schedules.map(cleanSchedule).forEach(s => {
          if(!updateMap['schedules']) updateMap['schedules'] = {}
          updateMap[`schedules`][`${s.id}`] = s
          mergeFields.push(`schedules.${s.id}`)
        })
      }
      if (activityIdsToDelete?.length) {
        activityIdsToDelete.forEach(id => {
          if(!updateMap['activities']) updateMap['activities'] = {}
          updateMap[`activities`][id] = deleteField()
        })
        this.store.dispatch(onsiteActions.removeActivities({ activityIds: activityIdsToDelete }))
      }
      if (scheduleIdsToDelete?.length) {
        scheduleIdsToDelete.forEach(id => {
          if(!updateMap['schedules']) updateMap['schedules'] = {}
          updateMap[`schedules`][id] = deleteField()
        })
        this.store.dispatch(onsiteActions.removeSchedules({ scheduleIds: scheduleIdsToDelete }))
      }
      console.log({ updateMap, mergeFields, activities, schedules, activityIdsToDelete, scheduleIdsToDelete, currentShedules: this._schedules })
      return setDoc(doc(this.db, `onsite/${this.eventService.eventId}`), updateMap, {merge: true, mergeFields})
    }

    /*** ACTIVITIES ***/
		public toggleActivityCompleted(activityId: string) {
      const activity = this._activities[activityId]
      if (!activity) {
        return console.log('could not find activity!', { activities: this._activities, activityId })
      }
      activity.completed = !activity.completed
      const url = `${this.api}/toggle-activity`
      this.http.post(url, {
        eventId: this.eventService.eventId,
        activityId,
        toggled: activity.completed
      }).pipe(take(1)).subscribe(_ => {}, error => {
        console.error({ error })
      });
      this.dontResetOnsiteTimelineTemporarily()
    }

		public addActivity(activity: OnsiteActivity) {
			return this.upsertWithDtoMapping({ activities: [activity] })
    }
    
		public modifyActivity(modifiedActivity: OnsiteActivity) {
      this.upsertWithDtoMapping({ activities: [modifiedActivity] })
		}

		public deleteActivity(activityId: string) {
      this.upsertWithDtoMapping({ activityIdsToDelete: [activityId] })
		}

    /*** SCHEDULES ***/
		public addSchedule(schedule: OnsiteSchedule) {
      return this.upsertWithDtoMapping({ schedules: [schedule] })
    }

    public changeStandaloneLocation({ standaloneId, location }) {
      const schedule = this._schedules[standaloneId]
      schedule.location = location
      return this.upsertWithDtoMapping({ schedules: [schedule] })
    }

		public changeStandaloneScheduleDate({ standaloneId, date }: {standaloneId: string, date: Date}) {
      const schedule = this._schedules[standaloneId]
      schedule.date = date_id(date)
			return this.upsertWithDtoMapping({ schedules: [schedule] })
    }
    
    public changeStandaloneTimeZone(standaloneId: string, timeZoneId: string) {
      const schedule = this._schedules[standaloneId]
      schedule.timeZoneId = timeZoneId
      return this.upsertWithDtoMapping({ schedules: [schedule] })
    }

    public changeStandaloneVenue(standaloneId: string, venue: Venue){
      const schedule = this._schedules[standaloneId]
      if (!schedule.timeZoneId) console.log("MISSING TIME ZONE ID!")
      schedule.venueId = venue ? venue.id : null
      if (!schedule.timeZoneId) schedule.timeZoneId = venue.timeZoneId
      return this.upsertWithDtoMapping({ schedules: [schedule] })
    }

		public changeStandaloneTitle({ standaloneId, title }) {
      const schedule = this._schedules[standaloneId]
			schedule.title = title
			return this.upsertWithDtoMapping({ schedules: [schedule] })
    }

		public changeSubscheduleTitle({ programId, subscheduleId, title }) {
      const schedule = this._schedules[subscheduleId]
      schedule.title = title
			return this.upsertWithDtoMapping({ schedules: [schedule] })
		}

		private deleteSubscheduleFromNode(node, subscheduleId) {
			const subscheduleIndex = node.subschedules.findIndex(sub => sub.id === subscheduleId)
				if (subscheduleIndex < 0) {
					console.log('Could not find subschedule in node!', { node, subscheduleId, programNodeCentersById: this.programNodeCentersById})
				}
			node.subschedules.splice(subscheduleIndex, 1)
		}

    private goToStandaloneEndAndAddSchedulesActivities(step: number, centerNode: ProgramNode, schedules, activities: OnsiteActivity[]) {
			let extensionDay = 0
			while (step < 0 ? centerNode.prev : centerNode.next) {
				centerNode = step < 0 ? centerNode.prev : centerNode.next
				const schedule = copyObjectWithProps(extensionScheduleProps, centerNode.schedule)
				schedule['extension'] = true
				extensionDay += step
				schedule['day'] = extensionDay
				schedules.push(schedule)
				centerNode.schedule.sessions.forEach((activity) => activities.push(this.convertActivityWithDay(activity, extensionDay)))
			}
		}

		private goToProgramEndAndAddSchedulesActivities(step: number, centerNode, schedules, activities: OnsiteActivity[]) {
			let day = 0
			let extensionDay = 0
			while (step < 0 ? centerNode.prev : centerNode.next) {
				centerNode = step < 0 ? centerNode.prev : centerNode.next
				day += step
				if (centerNode.extension) { // no need to save program day schedules, just activities for them
					const schedule = copyObjectWithProps(extensionScheduleProps, centerNode.schedule)
					schedule['extension'] = true
					extensionDay += step
					schedule['day'] = extensionDay
					schedules.push(schedule)
				}
				centerNode.subschedules.forEach(subschedule => subschedule.sessions.forEach((activity) => activities.push(this.convertActivityWithDay(activity, centerNode.extension ? extensionDay : day))))
			}
		}

    private getOnsiteDataFromCenter(centerId: string) {
      const schedules: OnsiteSchedule[] = []
			const activities: OnsiteActivity[] = []
			const centerNode = this.programNodeCentersById.get(centerId)
      switch (centerNode.standalone) {
        case true: {
          schedules.push(copyObjectWithProps(schedulePropertyNames, centerNode.schedule))
          centerNode.schedule.sessions.forEach((activity) => activities.push(this.convertActivityWithDay(activity, 0)))
          this.goToStandaloneEndAndAddSchedulesActivities(-1, centerNode, schedules, activities)
          this.goToStandaloneEndAndAddSchedulesActivities(1, centerNode, schedules, activities)
          break
        }
        default: { // onsite program
          centerNode.subschedules.forEach(subschedule => {
            const subscheduleDTO = copyObjectWithProps(schedulePropertyNames, subschedule)
            schedules.push(subscheduleDTO)
          }) // only need to save one copy of a subschedule as it cuts across all program days
          centerNode.subschedules.forEach(subschedule => subschedule.sessions.forEach((activity) => activities.push(this.convertActivityWithDay(activity, 0))))
          this.goToProgramEndAndAddSchedulesActivities(-1, centerNode, schedules, activities)
          this.goToProgramEndAndAddSchedulesActivities(1, centerNode, schedules, activities)
          break
        }
      }
      return { schedules, activities }
    }

    public deleteStandaloneSchedule(standaloneId: string) {
      const { schedules, activities } = this.getOnsiteDataFromCenter(standaloneId)
      const deleteData = { activityIdsToDelete: activities.map(a => a.id), scheduleIdsToDelete: schedules.map(s => s.id) }
      console.log({ deleteData })
      this.upsertWithDtoMapping(deleteData)
		}

    public doStuffThenUpdateTheDifference(programId: string, doStuff) {
      const beforeDeletingData = this.getOnsiteDataFromCenter(programId)
      const allActivityIds = beforeDeletingData.activities.map(a => a.id)
      const allScheduleIds = beforeDeletingData.schedules.map(s => s.id)

      doStuff()

      const { activities, schedules } = this.getOnsiteDataFromCenter(programId)
      const remainingActivityIds = getSet(activities, 'id')
      const remainingScheduleIds = getSet(schedules, 'id')
      const dataToSend = { activities, schedules, activityIdsToDelete: allActivityIds.filter(id => !remainingActivityIds.has(id)), scheduleIdsToDelete: allScheduleIds.filter(id => !remainingScheduleIds.has(id) )}
      console.log({ dataToSend, beforeDeletingData, activities, schedules, 
        activitiesToDelete: dataToSend.activityIdsToDelete.map(id => beforeDeletingData.activities.find(a => a.id === id)),
        schedulesToDelete: dataToSend.scheduleIdsToDelete.map(id => beforeDeletingData.schedules.find(s => s.id === id)) })
      return this.upsertWithDtoMapping(dataToSend)
    }

		public deleteExtensionDay(dateId: string, scheduleId: string) {
      if (!dateId || !scheduleId) {
        console.log("MISSING SCHEDULE OR DATE ID!", { scheduleId, dateId })
        return Promise.resolve()
      }

      const node = this.programNodesByDate[dateId].get(scheduleId)
      return this.doStuffThenUpdateTheDifference(node.schedule.scheduleId, () => {
        if (!node) {
          console.log({ node, dateId, scheduleId, pNodesByDate: this.programNodesByDate})
          return Promise.resolve()
        }
        if (node.prev) {
          node.prev.next = node.next
        }
        if (node.next) {
          node.next.prev = node.prev
        }
      })      
		}

		public deleteSubschedule({ subscheduleId, programId }) {
      return this.doStuffThenUpdateTheDifference(programId, () => {
        let node = this.programNodeCentersById.get(programId)
        while (node.prev) {
          node = node.prev
        }
        while (node.next) {
          this.deleteSubscheduleFromNode(node, subscheduleId)
          node = node.next
        }
        this.deleteSubscheduleFromNode(node, subscheduleId) // final node won't have a next
      })  
		}
}

